<template>
  <div class="wrap" style="overflow: hidden">
    <yd-backtop></yd-backtop>
    <div class="content">
      <yd-navbar title="用印记录" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
        <router-link to="/msoIndex" slot="left">
          <yd-navbar-back-icon></yd-navbar-back-icon>
        </router-link>
      </yd-navbar>
      <yd-tab v-model="tabSign" :prevent-default="false" :item-click="itemClick">
        <yd-tab-panel label="已用印" :badge="contractList[0].arrList.length" badge-bgcolor="#2f6fff" badge-scale="1">
          <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in contractList[0].arrList" :key="index">
            <yd-preview-header>
              <div slot="left" style="color:#000">用印时间</div>
              <div slot="right">
                {{item.sign_date}}
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{item.contract_no}}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{item.contract_name}}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{item.contract_no_area}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{item.supplier_no}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{item.supplier_name}}</div>
            </yd-preview-item>

          </yd-preview>
          <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="contractList[0].arrList.length==0">{{contractList[0].content}}</yd-preview>
        </yd-tab-panel>
        <yd-tab-panel label="已退回" :badge="contractList[1].arrList.length" badge-bgcolor="#2f6fff" badge-scale="1">
          <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in contractList[1].arrList" :key="index">
            <yd-preview-header>
              <div slot="left" style="color:#000">退回时间</div>
              <div slot="right">
                {{item.back_date}}
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left" style="color:red;text-align-last:auto;text-align:left;">退回原因:{{item.back_reason}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约日期</div>
              <div slot="right">{{item.order_date}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{item.begin_time}}~{{item.end_time}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{item.contract_no}}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{item.contract_name}}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{item.contract_no_area}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{item.supplier_no}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{item.supplier_name}}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="contractList[1].arrList.length==0">{{contractList[1].content}}</yd-preview>
        </yd-tab-panel>
      </yd-tab>
    </div>
  </div>

</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "msoIndex",
  data() {
    return {
      signCode:'',
      tabSign:0,
      btns:[],
      contractList: [
                {label: '已用印',status:5, content: '暂无待用印记录',arrList:[]},
                {label: '已退回', status:1,content: '暂无待用印记录',arrList:[]}

            ],
      userId: window.localStorage.getItem("checkUserId")
    };
  },
  methods: {
    itemClick(key) {
        this.$dialog.loading.open('数据加载中');
        this.tabSign = key;
        this.$dialog.loading.close();
    },
          //加载可预约合同资源
    getSignedList(){
      axios({
          method: "get",
          url: baseUrl + "signedList?userId="+this.userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.contractList[0].arrList = resp.data.over
            this.contractList[1].arrList = resp.data.back
          }
          })
    },
  },
  mounted() {
    if (this.userId == "" || this.userId == undefined) {
      this.$router.push({ path: "/login" });
    }
    this.getSignedList();
  }
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.yd-preview-header > :last-child {
  font-size: 0.28rem;
  margin-right: 0.2rem;
}
/deep/ .yd-tab-nav-item {
  margin: 0px 10px;
}
/deep/ .yd-tab-nav {
  width: fit-content !important;
}
/deep/ .yd-tab-nav .yd-tab-active {
  font-weight: bolder;
}

/deep/ .yd-preview-footer {
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/mso-list.vue